export const summaryRows: string[] = [
  'Volume 1 — Fondamenti di Gestione Ambientale',
  'Volume 2 — Risorse Naturali: Acqua, Suolo, Aria ed Energia',
  "Volume 3 — Inquinamento e Valutazione dell'Impatto Ambientale",
  'Volume 4 — Rifiuti, Riciclo ed Economia Circolare',
  'Volume 5 — Cambiamento Climatico, Biodiversità e Conservazione',
  'Volume 6 — Sistemi di Gestione Ambientale e Sostenibilità',
  'Bonus 1 — 30 Schede di Attività in Classe sulla Gestione Ambientale',
  'Bonus 2 — Kit di Verifica sulla Gestione Ambientale: Quiz e Prove con Soluzioni',
  'Bonus 3 — 20 Casi Pratici di Gestione Ambientale da Analizzare e Risolvere',
  'Bonus 4 — 20 Progetti Ambientali per la Classe, la Scuola e la Comunità',
  'Bonus 5 — Guida Pratica: 30 Strategie di Gestione Ambientale per la Scuola',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
